import { sendEvent } from "@/features/analytics/gtm/event";

type Props = {
  content_type: string;
  link_text: "catering" | "diety";
};

export const useSelectContentEvent = () => {
  const sendSelectContentEvent = ({ content_type, link_text }: Props) => {
    sendEvent({
      event: "select_content",
      content_type,
      link_text,
    });
  };

  return { sendSelectContentEvent };
};
